// extracted by mini-css-extract-plugin
module.exports = {"BankCardsContainer":"BankCards_BankCardsContainer__2Y-TW"};